export default [
  {
    path: "/scientific-management",
    name: "科学经营™ | 光华赋能独创的企业经营方法论体系 - BLM方法论+分拆对工作法",
    component: () => import("@/views/knowledge/scientific-management.vue"),
    meta: {
      title: "科学经营™"
    }
  },
  {
    path: "/blm",
    name: "BLM科学经营方法论 | 从战略制定到落地执行的完整经营体系 - 光华赋能",
    component: () => import("@/views/knowledge/blm.vue"),
    meta: {
      title: "BLM方法论"
    }
  },
  {
    path: "/fenchaidui",
    name: "分拆对™工作法 | 光华赋能独创的企业经营落地工具 - 让战略成为每个人的日常工作",
    component: () => import("@/views/knowledge/fenchaidui.vue"),
    meta: {
      title: "分拆对™工作法"
    }
  },
  {
    path: "/growth-camp",
    name: "光华赋能 | 方法论+工作法，可复制的结构性增长",
    component: () =>
      import("@/views/blm-scientific-management/big-growth-camp.vue"),
    meta: {
      title: "大增长营"
    }
  },
  {
    path: "/research-institute",
    name:
      "科研院|企业创始人与高管共同学习“用科学经营实现高质量发展”的一个实践社群",
    component: () =>
      import("@/views/blm-scientific-management/research-institute.vue"),
    meta: {
      title: "科研院"
    }
  }
];
